/**
 * Truncates a filename in the middle if it exceeds the maximum length
 * Preserves the file extension and shows start...end pattern
 */
export const truncateFilename = (filename: string, maxLength: number = 40): string => {
  if (!filename || filename.length <= maxLength) {
    return filename;
  }

  // Find the last dot to identify the extension
  const lastDotIndex = filename.lastIndexOf('.');

  // If no extension or extension is at the start, truncate from the end
  if (lastDotIndex <= 0) {
    return filename.slice(0, maxLength - 3) + '...';
  }

  const extension = filename.slice(lastDotIndex);
  const nameWithoutExt = filename.slice(0, lastDotIndex);

  // Calculate available space for the name (minus extension and ellipsis)
  const availableLength = maxLength - extension.length - 3; // 3 for '...'

  // If the available length is too small, just show extension with prefix
  if (availableLength < 10) {
    return filename.slice(0, maxLength - extension.length - 3) + '...' + extension;
  }

  // Split the available length between start and end
  const startLength = Math.ceil(availableLength * 0.6); // 60% at start
  const endLength = Math.floor(availableLength * 0.4); // 40% at end

  const start = nameWithoutExt.slice(0, startLength);
  const end = nameWithoutExt.slice(-endLength);

  return `${start}...${end}${extension}`;
};
